// Map common color names to hex codes
export const colorNameToHex: { [key: string]: string } = {
  'black': '#000000', 'white': '#FFFFFF', 'red': '#FF0000', 'blue': '#0000FF',
  'green': '#008000', 'yellow': '#FFFF00', 'grey': '#808080', 'gray': '#808080',
  'purple': '#800080', 'orange': '#FFA500', 'pink': '#FFC0CB', 'brown': '#A52A2A',
  'navy': '#000080', 'teal': '#008080', 'silver': '#C0C0C0', 'gold': '#FFD700',
  'beige': '#F5F5DC', 'tan': '#D2B48C', 'khaki': '#F0E68C', 'olive': '#808000',
  'maroon': '#800000', 'cyan': '#00FFFF', 'magenta': '#FF00FF', 'lime': '#00FF00',
  'indigo': '#4B0082', 'turquoise': '#40E0D0', 'coral': '#FF7F50', 'salmon': '#FA8072',
  'chocolate': '#D2691E', 'crimson': '#DC143C', 'navy blue': '#000080', 'royal blue': '#4169E1',
  'sky blue': '#87CEEB', 'midnight': '#191970', 'ultramarine': '#3F00FF', 'slate': '#708090',
  'charcoal': '#36454F', 'ash': '#B2BEB5', 'graphite': '#383838', 'dark grey': '#A9A9A9',
  'light grey': '#D3D3D3', 'cream': '#FFFDD0', 'ivory': '#FFFFF0', 'oat': '#ECE5CE',
  'oatmeal': '#ECE5CE', 'milk': '#FFFACD', 'taupe': '#B38B6D', 'moss': '#6B8E23',
  'forest': '#228B22', 'sage': '#9DC183', 'fern': '#4F7942', 'mint': '#98FF98',
  'seafoam': '#93E9BE', 'aqua': '#00FFFF', 'cobalt': '#0047AB', 'periwinkle': '#CCCCFF',
  'lavender': '#E6E6FA', 'plum': '#DDA0DD', 'violet': '#EE82EE', 'lilac': '#C8A2C8',
  'mauve': '#E0B0FF', 'rust': '#B7410E', 'bronze': '#CD7F32', 'copper': '#B87333',
  'pewter': '#E8E8E8', 'carrier': '#4A4A4A', 'stillwater': '#4A7BA7', 'fawn': '#E5D4C1',
  'luxe': '#B8860B', 'fade': '#D0A9E5', 'vital': '#00AA00', 'yamabuki': '#FFC000',
  'anzu': '#FF9900', 'eddo': '#4B0082', 'edo': '#4B0082', 'stardust': '#B0C4DE',
  'cosmic': '#2F4F7F', 'luna': '#E0E6FF', 'moth': '#F5F5DC', 'spark': '#FFD700',
  'succulent': '#6B8E23', 'skyward': '#87CEEB', 'grassland': '#9ACD32', 'oyster': '#E5E5E5',
  'mushroom': '#8B7355', 'asphalt': '#36454F', 'gravel': '#808080', 'stellar': '#191970',
  'galactic': '#2F4F7F', 'varsity': '#001A4D', 'hoka': '#003DA5', 'bistro': '#1C1C1C',
  'piedmont': '#666666', 'fiery': '#FF0000', 'spice': '#FF6347', 'curry': '#FFB800',
  'seal': '#4A4A4A', 'lake': '#4A7BA7', 'birch': '#FFFAF0', 'glacier': '#E0E6FF',
  'carrier grey': '#4A4A4A', 'white fawn': '#FFFAF0', 'blue fade': '#B0C4DE', 'green black': '#1A3A1A',
};

export const parseColorName = (colorName: string): string => {
  const cleanName = colorName.toLowerCase().trim();
  if (colorNameToHex[cleanName]) {
    return colorNameToHex[cleanName];
  }
  for (const [name, hex] of Object.entries(colorNameToHex)) {
    if (cleanName.includes(name) || name.includes(cleanName)) {
      return hex;
    }
  }
  return '#CCCCCC';
};

export const extractColorsFromText = (text: string): string[] => {
  const plainText = text.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ');
  const colorMatch = plainText.match(/Available Colors:\s*(.*?)(?:Available|$)/i);
  if (colorMatch && colorMatch[1]) {
    const colorString = colorMatch[1]
      .replace(/[•\-\*]/g, '')
      .trim();
    return colorString
      .split(',')
      .map((c: string) => c.trim())
      .filter((c: string) => c && c.length > 0 && c !== 'AVAILABLE COLORS');
  }
  return [];
};
